import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from '@progress/kendo-angular-notification';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { take } from 'rxjs';
import { ContributorRequest } from 'src/app/shared/models/add-contributor.model';
import { AuthStore } from 'src/app/stores/auth.store';
import { ContributorService } from 'src/app/shared/services/contributor-service';
import {
  dialogAnimationDuration,
  dialogTimer,
} from 'src/app/shared/constants/dialog-specs';
import { SVGIcon, trashIcon } from '@progress/kendo-svg-icons';
import { IIepContributor } from 'src/app/modules/iep/iep-document/interfaces/iep-contributor';
import { filter, get, head, map } from 'lodash';
import { IIepStaff } from 'src/app/modules/iep/iep-document/interfaces/iep-staff';
import { SubmitContributorData } from 'src/app/shared/models/submit-contributor.model';
import { DocumentStatus } from 'src/app/modules/referrals/interfaces/referrals.model';
import { User } from 'src/app/shared/models/user';
import { NOTIFICATION_MESSAGES } from 'src/app/shared/constants/notification-messages';
import { OperationType } from 'src/app/shared/enums/operation-type';

@Component({
    selector: 'app-contributor-dailogbox',
    templateUrl: './contributor-dailogbox.component.html',
    styleUrls: ['./contributor-dailogbox.component.scss'],
    standalone: false
})
export class ContributorDailogboxComponent
  extends DialogContentBase
  implements OnInit
{
  public opened: boolean = false;
  form: FormGroup;
  existingContributorsList: IIepContributor[];
  iepFormSk: string;
  sectionId: number;
  contributors: IIepStaff[];
  dbn: string = '24Q610';
  contributorName: string;
  public remove: SVGIcon = trashIcon;
  submitData: SubmitContributorData[] = [];
  user: User;
  readonly operationTypeRemove: OperationType = OperationType.Delete;
  readonly operationTypeSave: OperationType = OperationType.Add;

  constructor(
    private fb: FormBuilder,
    private contributorService: ContributorService,
    private notificationService: NotificationService,
    dialog: DialogRef,
    private authStore: AuthStore
  ) {
    super(dialog);
    this.user = this.authStore.UserInfo;
  }

  ngOnInit(): void {
    this.form = this.fb.group({ addContributor: ['', Validators.required] });
    this.contributorService
      .getContributors(this.dbn)
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      .pipe(take(1))
      .subscribe((data: IIepStaff[]) => {
        this.contributors = data;
      });
  }

  public close(): void {
    this.dialog.close();
  }

  removeContibutor(data: ContributorRequest): void {
    this.submitData.push(
      new SubmitContributorData({
        ...head(
          filter(
            this.existingContributorsList,
            (contributors: IIepContributor) =>
              contributors.personSk === data.personSk
          )
        ),
        operationType: this.operationTypeRemove,
        iepFormSk: this.iepFormSk,
        sectionId: this.sectionId,
      })
    );
    this.existingContributorsList = filter(
      this.existingContributorsList,
      (contributors: IIepContributor) => contributors.personSk !== data.personSk
    );
  }

  save(): void {
    this.submitData.push(
      ...map(
        get(this.form.value, 'addContributor'),
        (d: SubmitContributorData) =>
          new SubmitContributorData({
            ...d,
            actionType: DocumentStatus.SaveForLater,
            operationType: this.operationTypeSave,
            iepFormSk: this.iepFormSk,
            sectionId: this.sectionId,
            lastModuser: this.user.username,
          })
      )
    );
    this.submitContributorDetailsService(this.submitData);
  }

  submitContributorDetailsService(
    submitRequestdata: SubmitContributorData[]
  ): void {
    this.contributorService
      .submit(submitRequestdata)
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.notificationService.show({
            content: NOTIFICATION_MESSAGES.submitSuccess,
            cssClass: 'button-notification',
            hideAfter: dialogTimer,
            position: { horizontal: 'center', vertical: 'bottom' },
            animation: { type: 'slide', duration: dialogAnimationDuration },
            type: { style: 'success', icon: true },
          });
          this.dialog.close();
        },
        error: () => {
          this.notificationService.show({
            content: NOTIFICATION_MESSAGES.submissionFailed,
            hideAfter: dialogTimer,
            position: { horizontal: 'center', vertical: 'bottom' },
            animation: { type: 'slide', duration: dialogAnimationDuration },
            type: { style: 'error', icon: true },
          });
        },
      });
  }
}
